import { defineStore } from 'pinia';
import { type ModalInstance } from './types/modalInstance';

interface State {
  open: Record<string, ModalInstance<any>[]>;
}

export const useModalStore = defineStore('modals', {
  state: (): State => ({
    open: {
      default: [],
    },
  }),
});
